import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HTTPService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-howitswork-homepage',
  templateUrl: './howitswork-homepage.component.html',
  styleUrls: ['./howitswork-homepage.component.css'],
  providers: [HTTPService]

})
export class HowitsworkHomepageComponent implements OnInit {
  assetURL = environment.assetURL;

  constructor(private _httpService: HTTPService, private _router: Router, public sanitizer: DomSanitizer, public activeModal: NgbActiveModal) {

  }
  closeModal() {
    this.activeModal.close();
  }

  ngOnInit() {
    
  }
}
